import { Hitbox } from './hitbox';

export class RecyclingCenterHitbox extends Hitbox {
    
}